import { Stage1 } from "./stage_1";
import { Stage2 } from "./stage_2";
import { Stage3 } from "./stage_3";
import { Stage4 } from "./stage_4";
import { Stage5 } from "./stage_5";

export class StageManager {
    constructor() {
        this.stages = {
            1: new Stage1,
            2: new Stage2,
            3: new Stage3,
            4: new Stage4,
            5: new Stage5,
        }
    }
    validate(stage_id) {
        return this.stages[stage_id].validate();
    }
}